module.exports = __webpack_public_path__ + "static/media/confirm_password.d1a2c7b6.svg";